import { trans } from "@/service/i18n/i18n";
import { Button } from "@/components/ui/button";
import { ImageIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export function ThemeDefault({
  field,
  formField,
  onInput,
  removeImage,
  imageOnClick = () => {},
  setIsOpenModal,
}) {
  return (
    <>
      {!field.value ? (
        <div className="relative flex items-center gap-8 rounded-xl border-2 border-dashed p-4 transition-all hover:cursor-pointer hover:bg-zinc-50">
          <div className="bg-muted flex h-11 min-w-11 items-center justify-center rounded-md p-2">
            <ImageIcon size={24} className={"stroke-muted-foreground"} />
          </div>
          <div className="">
            <div className={cn(`text-foreground mb-1.5 text-base font-bold`)}>
              Przeciągnij plik lub kliknij.
            </div>
            <div className={cn(`text-sm font-normal text-zinc-600`)}>
              Obsługiwane formaty JPG, PNG | Maks. rozmiar 2 MB
            </div>
          </div>
          <input
            className={
              "absolute top-0 left-0 h-full w-full opacity-0 hover:cursor-pointer"
            }
            type="file"
            name={field.name}
            id={field.name}
            accept="image/*"
            onInput={(event) => {
              onInput(event);
            }}
            ref={formField.ref}
          />
        </div>
      ) : (
        <div className="relative flex items-center justify-between gap-8 rounded-xl border-2 border-dashed p-4">
          <div className="bg-muted flex w-[160px] items-center justify-between overflow-hidden rounded-md">
            <img src={field.value} className={"w-full"} alt={"upload"} />
          </div>
          <div className={"flex items-center gap-2"}>
            <Button
              onClick={() => setIsOpenModal(true)}
              type={"button"}
              variant={"secondary"}
            >
              Edytuj
            </Button>
            <Button
              onClick={removeImage}
              type={"button"}
              variant={"destructive"}
            >
              {trans("delete")}
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
